import { render, staticRenderFns } from "./tieStallStanchionHeatAbatement.vue?vue&type=template&id=b674eb3a&"
import script from "./tieStallStanchionHeatAbatement.vue?vue&type=script&lang=js&"
export * from "./tieStallStanchionHeatAbatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports